import axios from 'axios';

const api = axios.create({ baseURL: 'https://restaurant-backend-pi-nine.vercel.app/api' });

api.interceptors.request.use(cfg => {
    const token = localStorage.getItem('admin_token') || localStorage.getItem('token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export default api;
